import * as utils from "../_utils";
export const prototypal = utils.prototypal([], arr => [...arr]);
